import PropTypes from 'prop-types';
import React, { useMemo, useState, useEffect } from 'react';

import ReviewCard from 'containers/cards/Review';
import Page from 'containers/Page';
import { useApolloClient, useQuery } from '@apollo/client';
import { useRouter } from 'found';
import { GET_PROFILE_INFO } from '../schema/apolloQueries/commonQueries';
import { GET_NOTIFICATIONS_DETAILS } from '../schema/apolloQueries/notificationsQueries';

const ReviewPage = ({ viewer }) => {
  const {
    // router,
    match: {
      params: { nodeId },
    },
  } = useRouter();
  const client = useApolloClient();
  const profileData = client.readQuery({
    query: GET_PROFILE_INFO,
  });
  const { data } = useQuery(GET_NOTIFICATIONS_DETAILS, {
    variables: {
      modelId: nodeId,
      modelName: 'REVIEW',
    },
  });
  const [edge, setEdge] = useState(null);
  useEffect(() => {
    if (data?.getEventFeedById) {
      setEdge(data.getEventFeedById);
    }

  }, [data]);
  const setLikeOrUnlike = () => {
    setEdge(prevEdge => {
      let newObj = { ...prevEdge };
      newObj = {
        ...newObj,
        feedInfo: { ...newObj.feedInfo, liked: !newObj.feedInfo.liked, likeCount: !newObj.feedInfo.liked ? newObj.feedInfo.likeCount + 1 : newObj.feedInfo.likeCount - 1 },
      };
      return newObj;
    });
  };
  const setCommentCountEdgesState = () => {
    setEdge(prevEdges => {
      let newObj = { ...prevEdges };
      newObj = {
        ...newObj,
        feedInfo: { ...newObj.feedInfo, commentCount: newObj.feedInfo.commentCount + 1 },
      };
      return newObj;
    });
  };
  return (
    <Page
      backLink={useMemo(() => {
        return {
          href: '/notifications',
          label: 'Notifications',
        };
      }, [])}
      // backLink={useMemo(
      //   () => ({
      //     href: `/products/${product?.slug}`,
      //     label: `${product?.event.community.name} ${product?.name}`,
      //   }),
      //   [product],
      // )}
      title={useMemo(
        () => (profileData?.getProfile?.loggedIn && profileData?.getProfile.personId === data?.getEventFeedById?.personInfo?.id
          ? 'Your Review'
          : `${data?.getEventFeedById?.personInfo?.displayName || ''}'s Review`),
        [
          data?.getEventFeedById?.personInfo?.displayName,
          data?.getEventFeedById?.personInfo?.id,
          profileData?.getProfile?.loggedIn,
          profileData?.getProfile?.personId,
        ],
      )}
      trackerTitle='Reviews > View'
      viewer={viewer}
    >
      {edge && (
        <ReviewCard
          review={edge}
          viewer={viewer}
          onLikeOrUnlike={setLikeOrUnlike}
          onCommentCount={setCommentCountEdgesState}
        />
      )}
    </Page>
  );
};

ReviewPage.propTypes = {
  router: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default ReviewPage;
